import { AssetRelation, AssetRelationInput, AssetRelationType } from './assetRelations.types';

export const parseRelationTypeForFE = (data: any): AssetRelationType => ({
  key: data.key,
  categoryKey: data.category_key,
  name: data.name,
  direction1: data.direction_1,
  direction2: data.direction_2,
  isSymmetric: data.is_symmetric,
  sortOrder: data.sort_order,
});

export const parseRelationForFE = (data: any): AssetRelation => ({
  id: data.id,
  asset1: data.asset_1,
  asset2: data.asset_2,
  createdFromAssetId: data.created_from_asset_id ?? null,
  systemRelationTypeKey: data.system_relation_type_key,
  relationType: parseRelationTypeForFE(data.relation_type),
  description: data.description || '',
  canEdit: Boolean(data.can_edit),
  canDelete: Boolean(data.can_delete),
});

export const parseRelationsForFE = (rows: any[]) => rows.map(parseRelationForFE);

export const parseRelationInputForBE = (data: AssetRelationInput) => ({
  asset_a: data.assetA,
  asset_b: data.assetB,
  system_relation_type_key: data.systemRelationTypeKey,
  orientation: data.orientation,
  description: data.description || '',
});
